import "../../../css/DesignSystem/Buttons/ButtonTextLink.css";

const ButtonTextLink = ({
  children,
  label = "Button",
  className = "",
  disabled = false,
  type = "button",
  onClick,
  ...buttonProps
}) => {
  const content = children ?? label;

  return (
    <button
      {...buttonProps}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={["button-text-link FP_Content text-primary-1", className].filter(Boolean).join(" ")}
    >
      {content}
    </button>
  );
};

export default ButtonTextLink;
